import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXSugarRush = () => (
  <ArticleWrapper articleId="hmx_sugar_rush">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Sugar Rush</h1>
      {/* Add your HMX Sugar Rush article content here */}
      <p>This is a placeholder article for the HMX Sugar Rush switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXSugarRush;
